import { InspectionTypeOverrides } from 'types'

const siteviewOverride: InspectionTypeOverrides = (model) => {
  type DataLayersConfig = { dataLayersConfig?: { layers?: unknown[] } }
  const data = model?.data as unknown as DataLayersConfig | undefined
  const layers = data?.dataLayersConfig?.layers
  const hasMultipleLayers = Array.isArray(layers) && layers.length > 1
  return {
    feature: {
      layerHotbar: hasMultipleLayers,
      unitTaggingControls: true,
      defectsReportWithScreenshots: true,
      compassVisible: true,
    },
    annotationForm: {
      showDamageTypeSelector: true,
      showScreenshots: false,
      showNotes: true,
      showGeospatialLink: false,
    },
  }
}

export default siteviewOverride
